import React, { useState } from "react";
import {
  Container,
  Typography,
  Box,
  Button,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  TextField,
  InputAdornment,
  Divider,
  IconButton,
} from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";
import { Search } from "lucide-react";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import Header from "../components/Admin/header/Header";
import CloseIcon from "@mui/icons-material/Close";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";

import {
  DEFAULT_LIMIT,
  DEFAULT_ROWS_PER_PAGE_OPTIONS,
} from "../utils/constants";

import { useGetApi } from "../hooks/useGetApi";

import Loader from "../components/Loader/loader";
import ErrorMessage from "../components/ErrorMessage/errorMessage";
import { EditIcon } from "../comps/CustomIcons";
import { useNavigate } from "react-router-dom";
import { MASTER_RELIEF_TEST_DATAS } from "../_mock/mock";

const headLabel = [
  {
    id: 1,
    label: "Relief Type",
    value: "reliefType",
  },

  {
    id: 2,
    label: "Name",
    value: "name",
  },

  {
    id: 3,
    label: "Code",
    value: "code",
  },
  {
    id: 4,
    label: "",
    value: "",
  },
];
export default function MasterRelief() {
  const [search, setSearch] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_LIMIT);
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleModalOpen = () => {
    setModalOpen(true);
  };
  const handleAddItem = () => {
    navigate("add");
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedRow(null);
  };

  const handleEdit = (rowData) => {
    setSelectedRow(rowData);
    handleModalOpen();
  };
  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: "flex" }}>
        <Box>
          <Sidebar />
        </Box>
        <Box sx={{ width: "100%", pr: "90px" }}>
          {/* Search and Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              my: "20px",
              color: "#5D6A82",
            }}
          >
            <Typography sx={{ color: "inherit" }}>Relief Master</Typography>
            <IconButton>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              my: "20px",
            }}
          >
            <TextField
              placeholder="Search"
              size="small"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <select className="uid-select" defaultValue={"sno"}>
                        <option value="sno">Name</option>
                      </select>
                      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                      <Search />
                    </InputAdornment>
                  ),
                },
              }}
              value={search || ""}
              onChange={(event) => setSearch(event.target.value || "")}
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  display: "flex",
                  gap: 0.5,
                  minWidth: "150px",
                }}
                onClick={handleAddItem}
              >
                <AddCircleOutline />
                <Typography sx={{ color: "white" }}>New Relief</Typography>
              </Button>
            </Box>
          </Box>

          {/* Table */}

          <>
            <TableContainer component={Paper}>
              <Table aria-label="master ward table" sx={{ minWidth: 800 }}>
                <TableHead
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": { fontWeight: "bold" },
                  }}
                >
                  <TableRow>
                    {headLabel?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{ textAlign: option?.align || "left" }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {MASTER_RELIEF_TEST_DATAS?.map((row) => (
                    <TableRow key={row?._id}>
                      {headLabel?.map((column, index) =>
                        index !== headLabel?.length - 1 ? (
                          <TableCell key={column?.id}>
                            {row?.[column?.value] || "-"}
                          </TableCell>
                        ) : (
                          <TableCell
                            sx={{
                              textAlign: "right",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              gap: 1,
                            }}
                          >
                            <IconButton onClick={() => handleEdit(row)}>
                              <EditIcon
                                sx={{
                                  cursor: "pointer",
                                  color: "transparent",
                                  fontSize: "18px",
                                }}
                              />
                            </IconButton>
                            <IconButton>
                              <RemoveRedEyeOutlinedIcon />
                            </IconButton>
                            <IconButton>
                              <CloseIcon />
                            </IconButton>
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination */}

            <TablePagination
              rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
              component="div"
              count={0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        </Box>
      </Box>
    </Container>
  );
}
